export enum DialogTitles {
    RESEND_EMAIL="Resend email",
    SUCCESSFUL_EMAIL= "Email has successfully been sent",
    EMAIL_FAILURE= "Email failed",
    ACCEPT_APPLICATION = "Are you sure you want to accept this application?",
    CONFIRM_CONTRACT= "Confirm that the contract has been signed",
    CONTRACT_FAILED ="Contract failed",
    DECLINE_APPLICATION= "Are you sure you want to decline this application?",
    QUESTIONNAIRE = "Questionnaire",
    AMEND_BURSARY_AMOUNT = "Amend bursary amount",
    REVERT_APPLICATION = "Revert application",
    CONFIRM_APPLICATION_REVERT =`Are you sure you want to revert this application back?`,
    UPDATE_PROFILE_PICTURE =`Update profile picture`,
    APPLY_TO_RENEW_FUNDING="Apply to renew funding",
    APPLY_TO_RENEW_BURSARIES=`Apply to renew bursaries`,
    APPLICATION_FORM = `Application form`,
    CREATE_EVENT = "Create a new event",
    FILTER_RSVP = `Filter RSVPs`,
    ADD_INVITEES = "Add invitees",
    EDIT_EVENT = "Edit event details",
    CONFIRM_EVENT_DELETION = `Are you sure you want to cancel this event?`,
    UPDATE_EVENT_IMAGE = `Update event image`,
    EDIT_APPLICATION = `Edit student details`,
    TERMINATE_BURSARY = "Are you sure you want to terminate this bursary?",
    REQUEST_CHANGES = "Select the information you’d like the student to update",
    REQUEST_HOD_CHANGES = "Request motivation update",
    EDIT_PERSONAL_DETAILS = "Edit personal information",
    UPDATE_GRADE_AVERAGE = "Update grade average"
}
